module.exports = __webpack_public_path__ + "img/Diversity-2021.51f09dc7.png";